import { useCurrentUserApi } from 'infrastructure/api';

const RESOURCE_URL = '/employees';

interface Me {
  [key: string]: any;
}

interface MeService {
  getMe: () => Promise<Me>;
}

const useMeService = (): MeService => {
  const { sendGetRequest } = useCurrentUserApi();

  const getMe = async (): Promise<Me> => {
    const response = await sendGetRequest(`${RESOURCE_URL}/me`);
    return response.json();
  };

  return {
    getMe,
  };
};

export default useMeService;
